import React from 'react';

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Что-то пошло не так. Попробуйте позже.',
  onRetry,
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '300px',
      padding: '40px 20px',
      textAlign: 'center',
    }}>
      {/* Иконка ошибки — стилизованный круг с крестом */}
      <div style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'rgba(220, 53, 69, 0.1)',
        border: '2px solid rgba(220, 53, 69, 0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px',
        boxShadow: '0 0 20px rgba(220, 53, 69, 0.15)',
      }}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#dc3545"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </div>

      {/* Заголовок */}
      <h3 style={{
        color: '#f8f8f8',
        fontSize: '20px',
        fontFamily: 'var(--font-display)',
        fontStyle: 'italic',
        marginBottom: '12px',
      }}>
        Ошибка
      </h3>

      {/* Сообщение */}
      <p style={{
        color: '#b0b0b0',
        fontSize: '15px',
        fontFamily: 'var(--font-sans)',
        lineHeight: 1.6,
        maxWidth: '400px',
        marginBottom: onRetry ? '24px' : '0',
      }}>
        {message}
      </p>

      {/* Кнопка «Попробовать снова» */}
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
            border: 'none',
            padding: '12px 32px',
            borderRadius: '25px',
            color: '#0a0814',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            fontFamily: 'var(--font-sans)',
            transition: 'all 0.3s',
            boxShadow: '0 4px 15px rgba(212, 175, 55, 0.3)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(212, 175, 55, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(212, 175, 55, 0.3)';
          }}
        >
          Попробовать снова
        </button>
      )}
    </div>
  );
};

export default ErrorState;
